export const ratingMapping = {
  ONE: 1,
  TWO: 2,
  THREE: 3,
  FOUR: 4,
  FIVE: 5,
} as const;

export const QUERY_KEY_MAP = {
  sortBy: 'f_sort',
  userId: 'f_user',
  reviewId: 'f_review',
  reservationId: 'f_reservation',
  keywords: 'f_keyword',
  topics: 'f_topic',
  stayedMonths: 'f_time',
  overallScores: 'f_score',
  purposes: 'f_obj',
  companions: 'f_mem',
  additionalInformation: 'f_additional',
  ageRanges: 'f_age',
  genders: 'f_sex',
  providerId: 'f_provider',
  jrdp: 'f_jrdp',
  jrdpQuery: 'f_jrdpquery',
} as const;

export const FILTER_VALUE_MAP = {
  overallScores: {
    ONE: '1',
    TWO: '2',
    THREE: '3',
    FOUR: '4',
    FIVE: '5',
  },
  stayedMonths: {
    ONE: '01',
    TWO: '02',
    THREE: '03',
    FOUR: '04',
    FIVE: '05',
    SIX: '06',
    SEVEN: '07',
    EIGHT: '08',
    NINE: '09',
    TEN: '10',
    ELEVEN: '11',
    TWELVE: '12',
  },
  purposes: {
    LEISURE: 'l',
    BUSINESS: 'b',
  },
  genders: {
    MALE: 'm',
    FEMALE: 'f',
  },
  ageRanges: {
    TEN: '10',
    TWENTY: '20',
    THIRTY: '30',
    FORTY: '40',
    FIFTY: '50',
    SIXTY: '60',
    SEVENTY: '70',
    EIGHTY: '80',
  },
  sortBy: {
    RECOMMENDED: '0',
    LATEST: '1',
    HIGHEST_REVIEW_SCORE: '2',
    LOWEST_REVIEW_SCORE: '3',
  },
  companions: {
    SOLO: '1',
    FAMILY: '2',
    LOVER: '3',
    FRIEND: '4',
    COLLEAGUE: '5',
  },
  additionalInformation: {
    SMALL_CHILD: 'child',
    SENIOR_CITIZEN: 'elder',
    DISABILITIES: 'disability',
    ILLNESS: 'illness',
    PET: 'pet',
  },
} as const;

export const DEFAULT_SORT_OPTION = 'RECOMMENDED';

export const MAX_TEXT_COUNT = 100;

export const getImageUrl = (providerId: string) =>
  `https://trvimg.r10s.jp/share/HOTEL/${providerId}/${providerId}.jpg`;

export const defaultImageUrl =
  'https://img.travel.rakuten.co.jp/share/common/images/review/default_reviewer_icon.png';
